const COMPANY = {
  name: '티앤티 주식회사',
  bank: '국민은행',
  account: '703001-01-598295',
  contact: '1877-1827',
};

const MONTHLY_PRICE = 49000;

export function printPaymentReceipt({ gymName, ownerName, ownerEmail, periodMonths, senderName, confirmedAt, requestId }) {
  const amount = MONTHLY_PRICE * periodMonths;
  const amountFormatted = amount.toLocaleString('ko-KR');
  const dateStr = confirmedAt
    ? new Date(confirmedAt).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })
    : new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' });
  const shortId = requestId ? requestId.slice(0, 8).toUpperCase() : Math.random().toString(36).slice(2, 10).toUpperCase();

  const html = `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="UTF-8">
  <title>납부 확인서</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif; background: #f5f5f5; padding: 40px 20px; color: #111; }
    .receipt { max-width: 560px; margin: 0 auto; background: #fff; border: 1px solid #ddd; padding: 48px 40px; }
    .header { text-align: center; border-bottom: 2px solid #111; padding-bottom: 24px; margin-bottom: 28px; }
    .header h1 { font-size: 22px; font-weight: bold; letter-spacing: 4px; margin-bottom: 6px; }
    .header p { font-size: 13px; color: #666; }
    .section { margin-bottom: 24px; }
    .section-title { font-size: 12px; font-weight: bold; color: #888; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 10px; padding-bottom: 6px; border-bottom: 1px solid #eee; }
    .row { display: flex; justify-content: space-between; align-items: center; padding: 5px 0; font-size: 14px; }
    .row .lbl { color: #666; }
    .row .val { font-weight: 500; text-align: right; }
    .amount-box { background: #f8faff; border: 2px solid #2563eb; border-radius: 8px; padding: 20px; text-align: center; margin: 24px 0; }
    .amount-box .albl { font-size: 12px; color: #666; margin-bottom: 6px; }
    .amount-box .aval { font-size: 30px; font-weight: bold; color: #1d4ed8; }
    .amount-box .asub { font-size: 12px; color: #888; margin-top: 4px; }
    .footer { text-align: center; margin-top: 28px; padding-top: 20px; border-top: 1px solid #eee; }
    .footer p { font-size: 12px; color: #888; line-height: 1.6; }
    .stamp-wrap { display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 20px; }
    .company-name { font-size: 15px; font-weight: bold; }
    .stamp { width: 64px; height: 64px; border: 2.5px solid #1d4ed8; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #1d4ed8; font-weight: bold; font-size: 14px; letter-spacing: 2px; }
    @media print {
      body { background: #fff; padding: 0; }
      .receipt { border: none; padding: 20px; }
    }
  </style>
</head>
<body>
  <div class="receipt">
    <div class="header">
      <h1>납부 확인서</h1>
      <p>GYM Manager 서비스 이용료</p>
    </div>

    <div class="section">
      <div class="section-title">결제 정보</div>
      <div class="row"><span class="lbl">영수증 번호</span><span class="val">#${shortId}</span></div>
      <div class="row"><span class="lbl">납부 확인일</span><span class="val">${dateStr}</span></div>
      <div class="row"><span class="lbl">입금자명</span><span class="val">${senderName}</span></div>
      <div class="row"><span class="lbl">이용 기간</span><span class="val">${periodMonths}개월</span></div>
      <div class="row"><span class="lbl">결제 방법</span><span class="val">계좌이체</span></div>
    </div>

    <div class="section">
      <div class="section-title">이용 헬스장</div>
      <div class="row"><span class="lbl">헬스장명</span><span class="val">${gymName || '-'}</span></div>
      ${ownerName ? `<div class="row"><span class="lbl">대표자</span><span class="val">${ownerName}</span></div>` : ''}
      ${ownerEmail ? `<div class="row"><span class="lbl">이메일</span><span class="val">${ownerEmail}</span></div>` : ''}
    </div>

    <div class="amount-box">
      <div class="albl">납부 금액 (VAT 포함)</div>
      <div class="aval">₩${amountFormatted}</div>
      <div class="asub">월 49,000원 × ${periodMonths}개월</div>
    </div>

    <div class="section">
      <div class="section-title">공급자 정보</div>
      <div class="row"><span class="lbl">회사명</span><span class="val">${COMPANY.name}</span></div>
      <div class="row"><span class="lbl">입금 계좌</span><span class="val">${COMPANY.bank} ${COMPANY.account}</span></div>
      <div class="row"><span class="lbl">고객센터</span><span class="val">${COMPANY.contact}</span></div>
    </div>

    <div class="footer">
      <p>본 확인서는 GYM Manager 서비스 이용료 납부를 확인하는 문서입니다.</p>
      <div class="stamp-wrap">
        <span class="company-name">${COMPANY.name}</span>
        <div class="stamp">확인</div>
      </div>
    </div>
  </div>
  <script>window.addEventListener('load', () => window.print());</script>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=700,height=950');
  if (win) {
    win.document.write(html);
    win.document.close();
  }
}
